import React from 'react';
import style from './Services.module.scss';
import Card from 'react-bootstrap/Card';
import firstImgCard from '../../assets/img/imgCard-1.jpg';
import secondImgCard from '../../assets/img/imgCard-2.jpg';
import thirdImgCard from '../../assets/img/imgCard-3.jpg';
import fourthImgCard from '../../assets/img/imgCard-4.jpeg';
import fifthImgCard from '../../assets/img/imgCard-5.jpeg';
const Services = () => {
  return (
    <>
      <h1 className={style.title}>Servizi</h1>
      <div id="services" className={style.container}>
        <Card style={{ width: '20rem' }}>
          <Card.Img variant="top" src={firstImgCard} className={style.img} />
          <Card.Body>
            <Card.Title className={style.cardTitle}>Extension Ciglia e Laminazione</Card.Title>
            <Card.Text className={style.cardText}>
              Servizio professionale di extension ciglia di ogni tipologia e laminazione di ciglia e
              sopracciglia. Ogni trattamento è personalizzato in base alla morfologia dello sguardo
              e ai desideri della cliente, per ottenere un risultato armonioso, naturale ed
              elegante. L’obiettivo è valorizzare la bellezza dello sguardo, rendendolo intenso,
              curato e raffinato, nel pieno rispetto della salute e della struttura naturale delle
              ciglia
            </Card.Text>
          </Card.Body>
        </Card>
        <Card style={{ width: '20rem' }}>
          <Card.Img variant="top" src={secondImgCard} className={style.img} />
          <Card.Body>
            <Card.Title className={style.cardTitle}>Trattamenti Viso Professionali</Card.Title>
            <Card.Text className={style.cardText}>
              Trattamenti estetici avanzati per la cura profonda della pelle, realizzati con
              tecnologie moderne e protocolli personalizzati. Tra i principali: Hydrafacial,
              trattamenti anti-età e programmi rigeneranti per il recupero e il riequilibrio della
              pelle. Ogni percorso è studiato su misura in base alle esigenze individuali, per
              donare al viso luminosità, idratazione e un aspetto sano e curato.
            </Card.Text>
          </Card.Body>
        </Card>
        <Card style={{ width: '20rem' }}>
          <Card.Img variant="top" src={thirdImgCard} className={style.img} />
          <Card.Body>
            <Card.Title className={style.cardTitle}>Massaggio Viso Professionale</Card.Title>
            <Card.Text className={style.cardText}>
              Massaggio viso eseguito con tecniche avanzate per migliorare la luminosità, la
              tonicità e la compattezza della pelle. Favorisce il rilassamento muscolare, stimola la
              microcircolazione e il drenaggio linfatico, contribuendo a un viso più disteso, fresco
              e vitale. Ogni trattamento è personalizzato in base alle esigenze individuali, per
              valorizzare la naturale bellezza e salute della pelle
            </Card.Text>
          </Card.Body>
        </Card>
        <Card style={{ width: '20rem' }}>
          <Card.Img variant="top" src={fourthImgCard} className={style.img} />
          <Card.Body>
            <Card.Title className={style.cardTitle}>Epilazione Laser</Card.Title>
            <Card.Text className={style.cardText}>
              Trattamento di epilazione laser di ultima generazione per una pelle perfettamente
              liscia e vellutata, in modo rapido, confortevole e duraturo. La tecnologia avanzata
              del laser agisce in modo mirato e delicato sul bulbo pilifero, garantendo risultati
              sicuri ed efficaci senza irritazioni, tagli o peli incarniti. Un’esperienza di
              benessere e precisione, per dire addio ai metodi tradizionali e ottenere una pelle
              setosa senza sforzo
            </Card.Text>
          </Card.Body>
        </Card>
        <Card style={{ width: '20rem' }}>
          <Card.Img variant="top" src={fifthImgCard} className={style.img} />
          <Card.Body>
            <Card.Title className={style.cardTitle}>Endosfera Therapy Viso e Corpo</Card.Title>
            <Card.Text className={style.cardText}>
              Trattamento estetico avanzato per la cura e il benessere di viso e corpo, realizzato
              con tecnologia innovativa e protocolli personalizzati. Endosfera Therapy stimola la
              microcircolazione, migliora il tono cutaneo e favorisce il drenaggio dei liquidi,
              contribuendo a contrastare gli inestetismi e i segni del tempo. Ogni percorso è
              studiato su misura in base alle esigenze individuali, per donare alla pelle maggiore
              compattezza, luminosità e un aspetto sano e armonioso.
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default Services;
